export const namespacedPrefix = '[CATEGORIES]';
